// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QpVD3qAS0nYBtoQqAYoe {
  grid-area: nav;
  display: flex;
  flex-direction: row;
  background: rgb(54, 117, 139);
  background: linear-gradient(95deg, rgb(54, 117, 139) 13%, rgb(33, 140, 157) 58%, rgb(90, 156, 33) 97%);
  height: 4rem;
  border-top-left-radius: 1vmin;
  border-top-right-radius: 1vmin;
  margin-top: -1vmin;
  border: 0.1vmin solid var(--blue-1);
}

.yO6peHgUWkLrjEeOxzNq {
  font-size: 5vmin;
  margin: 1vmin 1vmin;
  font-variant: small-caps;
}

.r0qz0QDU_rtoXudq9SGQ {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.DEGMaUCVDuo5Jqd0H18t {
  font-size: 1.5vmin;
  text-align: center;
  margin-left: auto;
  height: 3vmin;
  padding: 0 1.5rem;
  background-color: var(--tan-1);
  color: var(--text-light);
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
}

.DEGMaUCVDuo5Jqd0H18t:not(:disabled):hover {
  color: var(--white);
  background-color: var(--yellow-1);
  transform: scale(1.05);
}

.pGuXSjiAF9ReSU4SwCSk {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/NavBar.module.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,sGAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,kBAAA;EACA,mCAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,4EAAA;AACJ;;AAEA;EACI,mBAAA;EACA,iCAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ","sourcesContent":[".NavBar {\n    grid-area: nav;\n    display: flex;\n    flex-direction: row;\n    background: rgb(54, 117, 139);\n    background: linear-gradient(95deg, rgba(54, 117, 139, 1) 13%, rgba(33, 140, 157, 1) 58%, rgba(90, 156, 33, 1) 97%);\n    height: 4rem;\n    border-top-left-radius: 1vmin;\n    border-top-right-radius: 1vmin;\n    margin-top: -1vmin;\n    border: .1vmin solid var(--blue-1);\n}\n\n.title {\n    font-size:  5vmin;\n    margin: 1vmin 1vmin;\n    font-variant: small-caps;\n}\n\n.buttonContainer {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n\n.buttons {\n    font-size: 1.5vmin;\n    text-align: center;\n    margin-left: auto;\n    height: 3vmin;\n    padding: 0 1.5rem;\n    background-color: var(--tan-1);\n    color: var(--text-light);\n    border: none;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;\n}\n\n.buttons:not(:disabled):hover {\n    color: var(--white);\n    background-color: var(--yellow-1);\n    transform: scale(1.05);\n}\n\n.hidden {\n    visibility: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavBar": `QpVD3qAS0nYBtoQqAYoe`,
	"title": `yO6peHgUWkLrjEeOxzNq`,
	"buttonContainer": `r0qz0QDU_rtoXudq9SGQ`,
	"buttons": `DEGMaUCVDuo5Jqd0H18t`,
	"hidden": `pGuXSjiAF9ReSU4SwCSk`
};
export default ___CSS_LOADER_EXPORT___;
